import { useState } from 'react';
import MediaPlaceholder from './MediaPlaceholder';
import './OurStory.css';

const STORY_PHOTO = '/images/Our Story/Our Story Image.png';

const STORY_ALT =
  'Sundaravel — Our Story, since 1969. Built on Trust. Driven by Quality. We manufacture more than 1 billion (1,000,000,000) match boxes a year, and have touched more than 50,000 lives through direct or indirect employment in the past 50 years. Keeping all the match sticks we produce in a year, we could go around the circumference of the earth 45 times — while strictly following the “Make in India” policy since 1969. Over more than 50 years, we have touched millions of lives and lit up billions of homes with our quality products.';

function OurStory() {
  const [photoFailed, setPhotoFailed] = useState(false);

  if (photoFailed) {
    return (
      <section id="our-story" className="section our-story">
        <div className="our-story-hero">
          <MediaPlaceholder
            label="Add photo: our story"
            color="var(--orange)"
            className="our-story-bg-placeholder"
          />
        </div>
      </section>
    );
  }

  return (
    <section id="our-story" className="section our-story">
      {/* Desktop/tablet: the whole banner (logo + text) at its own aspect
          ratio. Mobile: the same image cropped and stacked as two zoomed-in
          pieces (logo, then text) — see OurStory.css — so text stays legible
          instead of shrinking to fit the full banner on a narrow screen. */}
      <div className="our-story-hero our-story-hero-full">
        <img src={STORY_PHOTO} alt={STORY_ALT} onError={() => setPhotoFailed(true)} />
      </div>

      <div className="our-story-hero-mobile">
        <div className="our-story-hero our-story-crop-logo">
          <img src={STORY_PHOTO} alt={STORY_ALT} onError={() => setPhotoFailed(true)} />
        </div>
        <div className="our-story-hero our-story-crop-text">
          <img src={STORY_PHOTO} alt="" aria-hidden="true" />
        </div>
      </div>
    </section>
  );
}

export default OurStory;
